var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","flat":"","small":""},on:{"click":_vm.selectPlayer}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":"primary"}},on),[_vm._v("arrow_forward")])]}}])},[_c('span',[_vm._v("Seleccionar jugador")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }